import { SLOW_REQUEST_THRESHOLD } from '../constants/urls';
import { get } from './helpers/fetch';
import join from 'url-join';
import Team from '../models/Team';

export default class TeamDAO {
  accessToken: string;
  apiUrl: string;
  logging: Object;

  constructor(accessToken: string, apiUrl: string, logger: Object) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.logging = { logger, loggingThreshold: SLOW_REQUEST_THRESHOLD };
  }

  getUserTeam(teamId: string) {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl(`/query/teams/${teamId}`),
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    }).then(team => new Team({ ...team }));
  }

  getUrl(endpoint: string) {
    return join(this.apiUrl, endpoint);
  }
}